import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    IconButton,
    DialogContentText
    
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { IFile  } from "../../shered/services/api/utilidades/UtilidadesService";
import { ILstLiga } from "../../shered/components";
import { LigaService } from "../../shered/services/api/liga/LigaService";
import { EntradaTexto } from "../../shered/components/chat/EntradaDeTexto";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

export interface IDadosModalEvento {
    mensagem: string;
    label: string;
    titulo: string;
    acao: boolean;
    display: string;
    tipo: "error" | "warning" | "info" | "success";
    evento?: string;
    info?: any;

}
export type IModalProps = {
    //dados: IDadosModalEvento;
    children?: React.ReactNode;
    isModalVisible: boolean;
    onBackClickClose: () => void;
}


export const DialogChatEvent: React.FC<IModalProps> = ({ onBackClickClose, isModalVisible }) => {
    const [open, setOpen] = useState(isModalVisible);
    const [checked, setChecked] = useState(false);
    const navigate = useNavigate();
    const user = CookieService.get("access_user");
    const [lstLiga, setLstLiga] = useState<ILstLiga[]>([]);
    const [showModalChat, setShowModalChat] = useState(false);
    const [codigoLiga, setCodigoLiga] = useState(0);
    const [dadosArquivo, setDadosArquivo] = useState<IFile>();
    const [arquivo, setArquivo] = useState<any | null>("");
    const [redirecionar, setRedirecionar] = useState("");
    const [mensagem, setMensagem] = useState("");
    //const [dadosSalvar, setDadosSalvar ] = useState<IDetalheFaleConosco>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    useEffect(() => {
        if (!isModalVisible) {
            return;
        }
        else {
            setShowModalChat(true);
        }
        return;
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            await LigaService.getAllPorUsuario()
                .then((result) => {
                    const lst = result.data.dado;
                    let listaDrop: ILstLiga[] = lst.map(l => ({ codigo: l.codigo, label: l.nome }));
                    setLstLiga(listaDrop);

                })
                .catch((errors) => {
                    console.log(errors);
                });
        }
        fetchData();
    }, [])

    const handleClickOpen = () => {
        setOpen(true);
        onBackClickClose();
    };
    const handleClose = () => {
        setOpen(false);
        onBackClickClose();

    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
    };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        handleClose();
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }

    }

    const handleChangeFile = (newFile: any) => {
        //console.log(newFile);
        setArquivo(newFile);
        // if (dadosArquivo !== undefined) {
        //     setDadosArquivo({
        //         ...dadosArquivo,
        //         files: [...dadosArquivo.files, ...e.target.files],
        //     });
        // }
    }

    // const handleSalvarContato = async () => {
    //     var dadosSalvar: IDetalheFaleConosco = {
    //         codigo: 0,
    //         codUsuCriacao: user.codUsuario,
    //         arquivos: arquivo,
    //         arquivo_Anexo: "",                    
    //         mensagem: mensagem, 
    //         tipo: codigoOpcaoAssunto
    //     };
    //     if (arquivo !== null && arquivo !== "") {            
    //          await UtilidadeService.upLoadArquivo(arquivo)
    //         .then(respImg=> {             
    //             if (respImg.data.statusHTTP === 200) {
    //                 let dadosArquivo = respImg.data.dado[0];                    
    //                 dadosSalvar = {
    //                     codigo: 0,
    //                     codUsuCriacao: user.codUsuario,
    //                     arquivos: arquivo,                   
    //                     arquivo_Anexo: dadosArquivo.nome,                    
    //                     mensagem: mensagem,
    //                     tipo: codigoOpcaoAssunto
    //                 };
    //             }
    //         }).catch((erros) => {

    //         });

    //     }

    //     //handleClose();
    //     //console.log(dadosSalvar);
    //     UtilidadeService.createFaleConosco(dadosSalvar)
    //         .then((result) => {
    //             setShowModalMensagem(true);
    //             setDadosModalMensagem({
    //                 acao: true,
    //                 label: "",
    //                 tipo: "success",
    //                 mensagem: "Contato registrado com sucesso! Aguarde que entraremos em contato, obrigado!",
    //                 display: "none",
    //                 titulo: "Sucesso"
    //             });
    //             setRedirecionar("0");
    //         })
    //         .catch((errors) => {
    //             setShowModalMensagem(true);
    //             if (errors.response.status === 401) {
    //                 setDadosModalMensagem({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "error",
    //                     mensagem: "Sessão expirada!",
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //                 return;
    //             }
    //             setDadosModalMensagem({
    //                 acao: true,
    //                 label: "",
    //                 tipo: "error",
    //                 mensagem: "Não foi possível salvar os dados, tente novamente mais tarde! Caso não conseguir, favor entrar em contato com a TI.",
    //                 display: "none",
    //                 titulo: "Atenção"
    //             });
    //         });
    // }

    return (
        <div >
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Button variant="outlined" onClick={handleClickOpen} sx={{ display: "none" }}>
                Chat Fantasy
            </Button>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Chat
                </BootstrapDialogTitle>
                <DialogContent dividers sx={{ minWidth: "500px" }}>
                    <DialogContentText>
                        <Typography variant="h6">
                            Converse com as franquias de sua liga.
                        </Typography>
                        <Grid container direction="column">
                            <Grid container size={{xs:12, sm:12}} margin={2} direction="row" spacing={2} sx={{ width: "90%" }}>
                                <Grid size={{xs:12, sm:4}} >
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Liga</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Liga"
                                            value={codigoLiga}
                                            onChange={(e) => setCodigoLiga(Number(e.target.value))}
                                            defaultValue={0}>
                                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                            {
                                                lstLiga.map(qtd =>
                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid size={{xs:12, sm:12}} >
                                    <EntradaTexto />
                                </Grid>                                
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                    {showModalChat &&
                        <Button
                            //onClick={() => handleSalvarContato()}
                            autoFocus>Enviar
                        </Button>}
                </DialogActions>
            </BootstrapDialog>
        </div >
    )
};